<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "vehicle-model-title" | translate }}</mat-label
      ><input
        type="text"
        (keydown)="checkBackspace($event)"
        matInput
        formControlName="name"
        [matAutocomplete]="auto"
        required
      />
      <button
        *ngIf="searchForm.get('name').value"
        matSuffix
        mat-icon-button
        (click)="clearFormEmmiter()"
      >
        <mat-icon fontIcon="bosch-ic-close"></mat-icon>
      </button>
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let vehicle of (vehicles$ | async)?.content"
          (onSelectionChange)="handleVehicleChange($event, vehicle)"
          [value]="vehicle.licensePlate + ' - ' + vehicle.model.displayName"
          class="autocomplete"
        >
          {{ vehicle.licensePlate }} - {{ vehicle.model.displayName }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="!this.searchForm.valid">{{
        requiredText || "required-model" | translate
      }}</mat-error>
    </mat-form-field>
  </div>
</form>
